<template>
    <!--<h1 class="test2">Ceci est un test!!</h1>
    <button @click="showGrid">Testez allez!!!!</button>-->
    <div class="contrainer-page">
        
        <div :class="appliLance">
            <h1 class="title">{{appliLance}}</h1>
        </div>
        <div class="container-recherche">
            <div class="">
                <FicheDescriptive  v-bind:patientCourant="patientCourant" />
            </div>
            <div class="btnShowGrid">
                <input @click="showGrid" type="image" :src="loupe" alt="submit" width="30" height="30" style="font-size:14px;padding:0;margin:0" />
            </div>
            <div class="container-grid-btnShowGrid">
                <div class="laGrid">
                    <Grid @setModifEnTempsReel="setModifEnTempsReel" v-bind:lesPatients="lesPatients" @setPatientCourant="setPatientCourant" @setLesPatients="setLesPatients" />
                </div>
            </div>

        </div>
    </div>
    <div>
        {{patientCourant.key}}
    </div>
</template>
<style>
   
    
    *{
        margin: 0;
        padding: 0;
    }
    .title {
        text-align: center;
    }
    .Altyse .title {
        color:red;
    }
    .Fisimed .title {
        color: darkblue;
    }
    .container-recherche {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        
    }
    .btnShowGrid {
        display: none;
        transition: all 0.5s ease-in-out;
    }
    .container-grid-btnShowGrid {
        transition: all 0.5s ease-in-out;
    }
    @media (max-width: 650px) {
        .container-recherche{
            /*width: 90%;*/
            width: 100%;
        }
        *{
            font-size: 16px;
        }
        .container-grid-btnShowGrid {
            position: fixed;
            top: 0;
            left: 110%;
            background: #1E90FF;
            padding: 7px;
            bottom: 0;
            overflow: scroll;
        }
        .tableRecherche-container{
            height: auto;
        }
        .container-grid-btnShowGrid.active {
            left: 50px;
        }
        .btnShowGrid {
            display: block;
            position: fixed;
            right: 0;
            /*background-color: #ff8181;*/
        }
        .btnShowGrid.active{
            left: 10px;
            z-index: 10000;
        }
    }
</style>
    <script>
        import { defineComponent } from 'vue';
        import Grid from './Grid.vue'
        import FicheDescriptive from './FicheDescriptive.vue'
        import Patient from '../script/Patient.js';
        import loupe from '../images/loupe.png';

        export default defineComponent({
            components: {
                Grid,
                FicheDescriptive,
            },

            data: function () {
                return {
                    loupe,
                    modifEnTempsReel : false
                }
            },

            computed: {
                comp() {
                    return "Je suis comp"
                },
                patientCourant() {
                    // Defaut {} : evite le crash du template ({{patientCourant.key}}) et du
                    // prop passe a FicheDescriptive quand aucun patient n'est encore selectionne.
                    return this.$store.getters["ConnexionStore/getPatientCourant"] || {};
                },
                lesPatients() {
                    return this.$store.getters["ConnexionStore/getLesPatients"];
                },
                appliLance() {
                    return this.$store.getters["ConnexionStore/getAppliLance"];
                },
                test() {
                    return this.$store.getters["ConnexionStore/getTest"];
                }
            },

            methods: {
                modifPatientCourant() {
                    Patient.modifierPatient(this.patientCourant);
                },
                setModifEnTempsReel(bool) {
                    this.modifEnTempsReel = bool;
                    return true;
                },
                testShow() {
                    console.log(this.lesPatients);
                },
                setPatientCourant(n) {
                    this.$store.dispatch("ConnexionStore/setPatientCourant", n.Key);
                    this.$router.push({ name: this.appliLance+"RechercheID", params : { id: n.Key }});
                    return true;
                },

                setLesPatients(critere) {
                    this.$store.dispatch("ConnexionStore/setLesPatientsBySearh", critere);
                },

                showGrid() {
                    var laGrid = document.querySelector(".container-grid-btnShowGrid");
                    if (laGrid) laGrid.classList.toggle("active");

                    var tableRecherche = document.querySelector(".tableRecherche-container");
                    if (tableRecherche) tableRecherche.classList.toggle("active");
                    var btnShowGrid = document.querySelector(".btnShowGrid");
                    if (btnShowGrid) btnShowGrid.classList.toggle('active');
                },

                clicker() {
                    this.getPatientById(4685);
                    console.log('--------');
                    console.log(this.bool);
                    console.log('--------');
                },
                placerBtnShowGrid() {
                    var btnShowGrid = document.querySelector(".btnShowGrid");
                    if (btnShowGrid) btnShowGrid.style.top = window.screen.height / 2 + 'px';
                }
            },

            props: ['storeName'],
            mounted() {
                console.log("component Recherche created");
                this.$store.dispatch("ConnexionStore/setPatientCourant", this.id);
                this.$store.dispatch("ConnexionStore/setLesPatientsBySearh", "");
                window.addEventListener('resize', () => {
                    var btnShowGrid = document.querySelector(".btnShowGrid");
                    if (btnShowGrid) btnShowGrid.style.top = window.screen.height / 2 + 'px';
                });
            },
            created() {
            },
            watch: {
                patientCourant: {
                    handler(newValue, oldValue) {
                        if (this.modifEnTempsReel) {
                            this.modifPatientCourant();
                        }
                        else {
                        }
                    },
                    deep: true
                },
            }

        });
    </script>
